export default "__VITE_ASSET__CaA2Tp9O__"